
<div class="global-background">
    <!-- First button row -->
    <div class="buttons-row-1">
        <!-- Button - Open DICM -->
        <button 
            mat-raised-button 
            color="primary"
            class="base_buttons full_width"
            (click)="fileInput_DICOM.click()">
                {{languageService.Strings.buttons.button_openDicom}}
        </button>
        <!-- Button - Classify -->
        <button 
            mat-raised-button 
            color="primary"
            class="base_buttons full_width"
            (click)="buttonClassify()" 
            [disabled]="applicationState < 1">
                {{languageService.Strings.buttons.button_classify}}
        </button>
        <!-- Button - Data -->
        <button 
            mat-raised-button 
            color="primary"
            class="base_buttons full_width"
            (click)="buttonData()" 
            [disabled]="applicationState < 2">
                {{languageService.Strings.buttons.button_data}}
        </button>
        <!-- Button - Modify -->
        <button 
            mat-raised-button 
            color="primary"
            class="base_buttons full_width"
            (click)="buttonModify()" 
            [disabled]="applicationState < 2">
                {{languageService.Strings.buttons.button_modify}}
        </button>
        <!-- Button - Results -->
        <button 
            mat-raised-button 
            color="primary"
            class="base_buttons full_width"
            (click)="buttonResults()" 
            [disabled]="applicationState < 2">
                {{languageService.Strings.buttons.button_results}}
        </button>
    </div>
    <!-- Images row -->
    <div class="images-row">
        <div class="canvas-image" style="position: relative;">
            <canvas 
                #canvasElement 
                class="canvas-image"
                style="position: absolute; left: 0; top: 0; z-index: 1;">
            </canvas>
            <canvas 
                #canvasElement_Overlay 
                class="canvas-image" 
                (wheel)="canvas_onWheel($event)" 
                style="position: absolute; left: 0; top: 0; z-index: 2;">
            </canvas>
        </div>
    </div>
</div>


<!-- Waiting spinner -->
<div *ngIf="(displayWaitingSpiner)" >
    <app-waiting-spinner [waitingMessage]="waitingMessage" ></app-waiting-spinner> 
</div>


<!-- Invisible file inputs -->
<input 
    #fileInput_DICOM
    type="file" 
    class="file_input"
    (change)="onFileSelected_DICOM($event)"
>